import { forwardRef, memo } from "react";

import SchoolInfo from "./SchoolInfo";
import FooterNotes from "./FooterNotes";
import TitleSection from "./TitleSection";
import HeaderSection from "./HeaderSection";
import PaymentNotice from "./PaymentNotice";
import FinancialTable from "./FinancialTable";
import SubjectsTables from "./SubjectsTables";
import TTSubjectsTable from "./TTSubjectsTable";
import CAPSubjectsTable from "./CAPSubjectsTable";
import SignatureSection from "./SignatureSection";
import TTTSubjectsTable from "./TTTSubjectsTable";
import BACCSubjectsTable from "./BACCSubjectsTable";
import PROBSubjectsTable from "./PROBSubjectsTable";
import BEPCSubjectsTable from "./BEPCSubjectsTable";
import TTNewSubjectsTable from "./TTNewSubjectsTable";
import RegistrationNotice from "./RegistrationNotice";
import DISOALSubjectsTable from "./DISOALSubjectsTable";
import { SchoolWithExamRegistration, ExamType } from "../../types/types";

interface SchoolExamReportContentProps {
  registrationData: SchoolWithExamRegistration | null;
  selectedExamTypes: ExamType[];
  isALSelected: boolean;
  examTypes: ExamType[];
  selectedExamTypeIds: number[];
}

const SchoolExamReportContent = memo(
  forwardRef<HTMLDivElement, SchoolExamReportContentProps>(
    (
      {
        registrationData,
        selectedExamTypes,
        isALSelected,
        examTypes,
        selectedExamTypeIds,
      },
      ref
    ) => {
      return (
        <div className="gceo-container" ref={ref}>
          {/* Header Section */}
          <HeaderSection
            examTypes={examTypes}
            selectedExamTypes={selectedExamTypes}
          />

          {/* Title */}
          <TitleSection registrationData={registrationData} />

          {/* Payment Notice */}
          <PaymentNotice />

          {/* School Information */}
          <SchoolInfo registrationData={registrationData} />

          {/* Financial Transactions Table FOR GCE O/L & GCE A/L */}
          <FinancialTable
            registrationData={registrationData}
            selectedExamTypeIds={selectedExamTypeIds}
          />

          {/* Registration Notice */}
          <RegistrationNotice registrationData={registrationData} />

          <SubjectsTables
            registrationData={registrationData}
            selectedExamTypes={selectedExamTypes}
            isALSelected={isALSelected}
          />

          <CAPSubjectsTable
            registrationData={registrationData}
            selectedExamTypes={selectedExamTypes}
          />

          <BACCSubjectsTable
            registrationData={registrationData}
            selectedExamTypes={selectedExamTypes}
          />

          <PROBSubjectsTable
            registrationData={registrationData}
            selectedExamTypes={selectedExamTypes}
          />

          <BEPCSubjectsTable
            registrationData={registrationData}
            selectedExamTypes={selectedExamTypes}
          />

          <TTSubjectsTable
            registrationData={registrationData}
            selectedExamTypes={selectedExamTypes}
          />

          <TTNewSubjectsTable
            registrationData={registrationData}
            selectedExamTypes={selectedExamTypes}
          />

          <TTTSubjectsTable
            registrationData={registrationData}
            selectedExamTypes={selectedExamTypes}
          />

          <DISOALSubjectsTable
            registrationData={registrationData}
            selectedExamTypes={selectedExamTypes}
          />

          {/* Footer Notes */}
          <FooterNotes registrationData={registrationData} />

          {/* Signature Section */}
          <SignatureSection registrationData={registrationData} />
        </div>
      );
    }
  )
);

SchoolExamReportContent.displayName = "SchoolExamReportContent";

export default SchoolExamReportContent;
